<template>
    <div class="vue-map-search">
        <vue-progress-bar v-if="!proceed"></vue-progress-bar>
        <div class="container-fluid store-search-container p-0" :class="{ 'show-list': showList }">
            <div class="row w-100 m-0 position-relative">
                <filter-form v-if="initialPopup && loadComplete" class="border-radius-main w-100" />

                <div class="d-flex flex-column left-map p-0" :class="`${ initialPopup ? 'd-none' : 'col-12 col-lg-4 col-xl-3'}`">
                    <filter-form v-if="loadComplete && !initialPopup" :inputOnly="true" class="border-l-bottom-secondary-l p-2 w-100"/>

                    <div class="sidebar-wrapper">
                        <div class="termin-sidebar box first-box v-sticky-top d-lg-block" :class="{ 'd-none': !showList }">
                            <stores-list :markers="markers"></stores-list>
                        </div>
                    </div>
                </div>

                <div class="map-overlay position-absolute col-sm-12 w-100 h-100" v-if="initialPopup && loadComplete" @click="removePopup"></div>

                <div class="right-map map-container p-0" :class="`col-12 ${ initialPopup ? 'right-initial' : 'col-lg-8 col-xl-9' }`">
                    <googleMap ref="map"></googleMap>
                </div>
            </div>
            <div class="sticky-map-or-list justify-content-center w-100 p-2 d-flex d-lg-none bg-white" v-if="!initialPopup || width <= 768">
                <div class="m-tabs w-100 px-5 px-md-10" :class="{ 'active': !showList }">
                    <div class="buttons-wrapper border-s-secondary">
                        <div class="before position-relative d-flex align-items-center">
                            <a href="#" @click="showHideList(true)" class="icon-left position-relative btn left btn-small w-100">
                             <span class="d-flex align-items-center justify-content-center">
                                <div class="icon-wrapper border-radius-main no-overflow ">
                                   <svg class="icon-base">
                                      <use xlink:href="/dist/icons/solid.svg#list"></use>
                                  </svg>

                                </div>
                                <span class="font-regular">{{text.list}}</span>
                             </span>
                            </a>
                            <a href="#" @click="showHideList(false)" class="icon-left position-relative btn right btn-small w-100">
                              <span class="d-flex align-items-center justify-content-center">
                                <div class="icon-wrapper border-radius-main no-overflow ">
                                   <svg class="icon-base">
                                     <use xlink:href="/dist/icons/solid.svg#map"></use>
                                   </svg>
                                </div>
                                <span class="font-regular">{{text.cart}}</span>
                              </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
         <div class="d-none">
                <li v-for="(item, index) in text.products">
                    {{ index }} - {{ item }}
                </li>
         </div>
    </div>

</template>

<script>
import GoogleMap from '@/components/GoogleMap'
import StoresList from '@/components/StoresList'
import FilterForm from '@/components/FilterForm'
import { mapState } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import ServiceDrupal from '@/services/ServiceDrupal.js'

export default {
    name: 'stores-search',
    components: {
        GoogleMap,
        StoresList,
        FilterForm
    },
    data () {
        return {
            loadComplete: false,
            showList: window.screen.width > 768 ? false : true,
            width: 1440,
            text: {
                cart: Drupal.t('Karte'),
                list: Drupal.t('Liste'),
                locDenied: Drupal.t('User Denied geolocation.'),
                products: {
                    btnFilterDelete: Drupal.t('Delete all filters'),
                    productsFound: Drupal.t('Products found'),
                    brands: Drupal.t('Brands'),
                    topBrands: Drupal.t('Top brands'),
                    alphabetical: Drupal.t('Alphabetical'),
                    apply: Drupal.t('Product Apply'),
                    moreProducts: Drupal.t('Show more products'),
                    genders: Drupal.t('For whom?'),
                    colors: Drupal.t('Color'),
                    shapes: Drupal.t('Shape'),
                    materials: Drupal.t('Material'),
                    types: Drupal.t('Find stores near by'),
                    wearTimes: Drupal.t('Wear times'),
                    sizes: Drupal.t('Lens sizes'),
                    traits: Drupal.t('Lens traits'),
                    frame: Drupal.t('Frame type'),
                    kinds: Drupal.t('Lens kinds'),
                    waterContents: Drupal.t('water content'),
                    // workaround that translation from drupal works used in product listing vue app
                    // avonis/source/_patterns/organisms/vue/product
                    subcribableText: Drupal.t('Show products only with subscription'),
                    fittingBoxText: Drupal.t(`Only products with virtual try on`),
                    uvFilterText: Drupal.t(`Only products with UV filter`),
                    subscribableText: Drupal.t(`Only products which are subscribable`),
                    sustainable: Drupal.t(`Sustainable`),
                    polarizing: Drupal.t(`Polarising`),
                    eyesightCapable: Drupal.t(`Visual acuity capable`),
                    varifocal: Drupal.t(`Varifocal capable`),
                    mirrored: Drupal.t(`Mirrored`),
                }

            }
        }
    },
    watch: {
        progressLoadings: {
            deep: true,
            handler (loading) {
                if (loading.status) {
                    this.$Progress.start()
                } else {
                    this.$Progress.finish()
                }
            }
        },
        completed: function (value) {
            if (value) {
                this.loadComplete = true
                if (ServiceDrupal.getSettings().path.currentQuery) {
                    if (ServiceDrupal.getSettings().path.currentQuery.address) {
                        let searched = {
                            formatted_address: ServiceDrupal.getSettings().path.currentQuery.address,
                            geometry : {
                                location :{
                                  lat : parseFloat(ServiceDrupal.getSettings().path.currentQuery.lat),
                                  lng : parseFloat(ServiceDrupal.getSettings().path.currentQuery.lng)
                                }
                            }
                        }
                       this.updatePlace(searched)
                    } else if (ServiceDrupal.getSettings().path.currentQuery.mein) {
                        navigator.geolocation.getCurrentPosition(
                            position => {
                                const place = {
                                    geometry: {
                                        locationFromNavigator: {
                                            lat: position.coords.latitude, lng: position.coords.longitude
                                        }
                                    }
                                }

                                this.updatePlace(place)
                            },
                            error => {
                                const notification = {
                                    type: 'error',
                                    localisation: true,
                                    message: Drupal.t('User Denied geolocation.')
                                }
                                this.$store.dispatch('stopLoading', null, { root: true })
                                this.$store.dispatch('notification/add', notification, { root: true })
                            })
                    }
                } else {
                    this.$store.dispatch('map/updatePlace', this.defaultCenter)
                    this.$store.dispatch('store/update', {
                        google: this.google,
                        radius: 500,
                        place: this.defaultCenter,
                        center: this.defaultCenter,
                        live: true
                    })
                }
            }
        }
    },
    computed: {
        markers: {
            get () {
                return this.$store.state.store.markers
            },
            set (value) {
                this.$store.commit('store/SET_MARKERS', value)
            }
        },
        ...mapState({
            services: state => state.etermin.services,
            radius: state => state.map.radius,
            defaultCenter: state => state.map.defaultCenter,
            center: state => state.map.center
        }),
        ...mapState([
            'initialPopup',
            'proceed',
            'loading'
        ]),
        google: gmapApi,
        progressLoadings () { return this.$store.state.loading },
        completed: function () {
            return this.markers.length > 0 && this.google !== null
        }
    },
    methods: {
        showHideList (newState) {
            this.showList = newState
        },
        updatePlace (place) {
            this.$store.dispatch('removeIntitalPopup', {})
            this.$store.dispatch('map/disableLiveSearch', null)
            this.$store.dispatch('map/updateRadius', this.radius)
            this.$store.dispatch('map/updatePlace', place)
            this.$store.dispatch('store/update', {
                google: this.google,
                radius: this.radius,
                place: place,
                center: this.center,
                live: false
            })
        },
        removePopup () {
            this.$store.dispatch('removeIntitalPopup', {})
        },
        loadStores () {
            this.$store.dispatch('store/fetch')
        }
    },
    async mounted () {
        this.$store.dispatch('startLoading', { message: 'Loading stores ...' }, { root: true })
        await this.loadStores()
        this.width = window.screen.width;
        if(this.width<768){
            this.$store.dispatch('removeIntitalPopup', {})
        }
    }
}
</script>
